export const DEFAULT_TIMEZONE = 'Europe/Moscow';

export const TIMEZONE_OPTIONS = [
  ['Europe/Kaliningrad', 'Калининград'],
  ['Europe/Moscow', 'Москва'],
  ['Europe/Samara', 'Самара'],
  ['Asia/Yekaterinburg', 'Екатеринбург'],
  ['Asia/Omsk', 'Омск'],
  ['Asia/Krasnoyarsk', 'Красноярск'],
  ['Asia/Irkutsk', 'Иркутск'],
  ['Asia/Yakutsk', 'Якутск'],
  ['Asia/Vladivostok', 'Владивосток'],
  ['Asia/Magadan', 'Магадан'],
  ['Asia/Kamchatka', 'Камчатка'],
  ['Europe/Minsk', 'Минск'],
  ['Asia/Tbilisi', 'Тбилиси'],
  ['Asia/Yerevan', 'Ереван'],
  ['Asia/Almaty', 'Алматы'],
  ['Asia/Tashkent', 'Ташкент'],
  ['Europe/Istanbul', 'Стамбул'],
  ['Europe/Berlin', 'Берлин'],
  ['Europe/Paris', 'Париж'],
  ['Europe/London', 'Лондон'],
  ['Asia/Dubai', 'Дубай'],
  ['Asia/Jerusalem', 'Иерусалим'],
  ['America/New_York', 'Нью-Йорк'],
  ['America/Chicago', 'Чикаго'],
  ['America/Denver', 'Денвер'],
  ['America/Los_Angeles', 'Лос-Анджелес'],
  ['Asia/Bangkok', 'Бангкок'],
  ['Asia/Tokyo', 'Токио'],
].map(([value, city]) => ({ value, city }));

export function timezoneOffset(timezone = DEFAULT_TIMEZONE, date = new Date()) {
  try {
    const part = new Intl.DateTimeFormat('ru-RU', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    }).formatToParts(date).find(item => item.type === 'timeZoneName')?.value || '';
    return part.replace('GMT', 'UTC').replace('−', '-');
  } catch {
    return '';
  }
}

export function timezoneLabel(timezone = DEFAULT_TIMEZONE) {
  const option = TIMEZONE_OPTIONS.find(item => item.value === timezone);
  const name = option?.city || timezone;
  const offset = timezoneOffset(timezone);
  return offset ? `${name}, ${offset}` : name;
}

export function todayInTimezone(timezone = DEFAULT_TIMEZONE) {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return `${values.year}-${values.month}-${values.day}`;
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}
